type ClassDictionary = Record<string, boolean | null | undefined>;
type ClassValue =
  | string
  | number
  | null
  | false
  | undefined
  | ClassValue[]
  | ClassDictionary;

const appendClass = (value: ClassValue, collector: string[]) => {
  if (!value) {
    return;
  }

  if (typeof value === "string" || typeof value === "number") {
    collector.push(String(value));
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => appendClass(item, collector));
    return;
  }

  Object.entries(value).forEach(([key, condition]) => {
    if (condition) {
      collector.push(key);
    }
  });
};

export const cn = (...values: ClassValue[]): string => {
  const collector: string[] = [];
  values.forEach((value) => appendClass(value, collector));
  return collector.join(" ");
};
